import moment from "moment";
import { useTranslation } from "@refinedev/core";
import { IPickupSportParticipantDetail } from "interfaces";
import { getSelfPickupStatus } from "utills/helpers";
import { CollapsibleSection } from "components/collapsibleSection";
import { Tag } from "components/tag";

export const PickupInformationSection = ({
  participantDetailData,
}: {
  participantDetailData: IPickupSportParticipantDetail | null;
}) => {
  const { translate } = useTranslation();

  return (
    <CollapsibleSection
      label={translate("pickup-information")}
      defaultOpen={true}
    >
      <div
        className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6"
        style={{ wordBreak: "break-word" }}
      >
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-1">
          <div className="col-span-2">
            <p className="font-medium">Pickup Email</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.email_pick}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-name")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.name_pick}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">{translate("pos-name")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.pos}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-7">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-at")}</p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.pick_time
                ? moment(participantDetailData.participant.pick_time).format(
                    "DD/MM/YYYY HH:mm:ss",
                  )
                : ""}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-9">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-image")}</p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.image_pick ? (
                <img
                  className="w-auto max-w-full max-h-20"
                  src={participantDetailData?.participant.image_pick}
                  alt="PickupImage"
                />
              ) : (
                ""
              )}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-id")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.id_card_pick}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-phone")}</p>
          </div>
          <div className="col-span-4">
            <p>{participantDetailData?.participant.phone_pick}</p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">{translate("ewaiver-status")}</p>
          </div>
          <div className="col-span-4">
            <Tag
              text={
                participantDetailData?.participant?.is_online_checkin
                  ? translate("signed")
                  : translate("unsigned")
              }
              type={
                participantDetailData?.participant?.is_online_checkin
                  ? "green"
                  : "pink"
              }
            />
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-8">
          <div className="col-span-2">
            <p className="font-medium">{translate("pickup-method")}</p>
          </div>
          <div className="col-span-4">
            <p>
              {getSelfPickupStatus(
                participantDetailData?.participant.self_pick,
              )}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-10">
          <div className="col-span-2">
            <p className="font-medium">{translate("digital-signature")}</p>
          </div>
          <div className="col-span-4">
            {participantDetailData?.participant.signature ? (
              <img
                className="w-auto max-w-full max-h-20"
                src={participantDetailData?.participant.signature}
                alt="signature"
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </CollapsibleSection>
  );
};
